import { Progress, Tooltip } from 'antd';
import { Action, Journey, JourneyState } from 'interfaces/journey';

interface ProgressBarProps {
  journey: Journey;
}

const calculatePercentages = (
  totalPackages: number,
  deliveredPackages: number,
  failedPackages: number,
) => {
  let percentageStatus;
  let percentageDelivered;

  percentageDelivered = (deliveredPackages / totalPackages) * 100;
  percentageStatus =
    ((deliveredPackages + failedPackages) / totalPackages) * 100;

  return { percentageStatus, percentageDelivered };
};

const ProgressBar = ({ journey }: ProgressBarProps) => {
  const {
    totalPackages,
    deliveredPackages,
    failedPackages,
    pendingPackages,
    totalCollections,
    collectedCollections,
    failedCollections,
    pendingCollections,
  } = journey;

  const hasCollections = (totalCollections ?? 0) > 0;
  const total = (totalPackages ?? 0) + (totalCollections ?? 0);
  const done = (deliveredPackages ?? 0) + (collectedCollections ?? 0);
  const failed = (failedPackages ?? 0) + (failedCollections ?? 0);
  const pending = (pendingPackages ?? 0) + (pendingCollections ?? 0);

  if (!total) return <>No hay información de progreso</>;

  const { percentageStatus, percentageDelivered } = calculatePercentages(
    total,
    done,
    failed,
  );

  return (
    <Tooltip
      title={
        hasCollections
          ? journey.state === JourneyState.Finished
            ? `${done} resueltas / ${total - done} sin resolver`
            : `${done} resueltas / ${failed} sin resolver / ${pending} en ruta`
          : journey.state === JourneyState.Finished
            ? `${done} entregados / ${total - done} no entregados`
            : `${done} entregados / ${failed} no entregados / ${pending} en ruta`
      }
    >
      <Progress
        status={
          journey.state === JourneyState.Finished
            ? pending === 0
              ? 'success'
              : 'exception'
            : 'active'
        }
        percent={
          journey.state === JourneyState.Finished ? 100 : percentageStatus
        }
        success={{ percent: percentageDelivered }}
        showInfo={false}
        strokeColor="#ff4d4f"
      />
    </Tooltip>
  );
};

export default ProgressBar;
